import { createSlice } from "@reduxjs/toolkit";

const formSlice = createSlice({
  name: "form",
  initialState: {
    firstFormData: { Source: "", literacyData: [] },
    secondFormData: { Source: "", NumeracyData: [] },
    adultLiteracy: { Source: "", AdultLiteracyData: [] },
    youthLiteracy:{Source:"", YouthLiteracyRate:[]},
    thirdFormData: { AdultLiteracyData: [] },
    fourthFormData: { Source: "", ictSkillsData: [] },

  },
  reducers: {
    // --- First Form Actions ---
    setFirstFormData: (state, action) => {
      state.firstFormData = action.payload;
    },
    updateSource: (state, action) => {
      state.firstFormData.Source = action.payload;
      state.firstFormData.literacyData = state.firstFormData.literacyData.map((item) => ({
        ...item,
        source: action.payload,
      }));
    },
    updateLiteracyData: (state, action) => {
      state.firstFormData.literacyData = action.payload;
    },
    updateLiteracyDataYear: (state, action) => {
      state.firstFormData.literacyData = state.firstFormData.literacyData.map((item) => ({
        ...item,
        Census_Year: action.payload,
      }));
    },
    updateLiteracyDataProvince: (state, action) => {
      state.firstFormData.literacyData = state.firstFormData.literacyData.map((item) => ({
        ...item,
        Province_Id: action.payload,
      }));
    },

    // --- Second Form Actions ---
    setSecondFormData: (state, action) => {
      state.secondFormData = action.payload;
    },
    updateSourceOfSecondForm: (state, action) => {
      state.secondFormData.Source = action.payload;
      state.secondFormData.NumeracyData = state.secondFormData.NumeracyData.map((item) => ({
        ...item,
        source: action.payload,
      }));
    },
    updateSecondLiteracyData: (state, action) => {
      state.secondFormData.NumeracyData = action.payload;
    },
    updateSecondLiteracyDataYear: (state, action) => {
      state.secondFormData.NumeracyData = state.secondFormData.NumeracyData.map((item) => ({
        ...item,
        Census_Year: action.payload,
      }));
    },
    updateSecondLiteracyDataProvince: (state, action) => {
      state.secondFormData.NumeracyData = state.secondFormData.NumeracyData.map((item) => ({
        ...item,
        Province_Id: action.payload,
      }));
    },

    // --- Third Form Actions ---
    setThirdFormData: (state, action) => {
      state.thirdFormData = action.payload;
    },
    updateSourceOfThirdForm: (state, action) => {
      state.adultLiteracy.Source = action.payload;
      state.adultLiteracy.AdultLiteracyData = state.adultLiteracy.AdultLiteracyData.map((item) => ({
        ...item,
        source: action.payload,
      }));
    },
    updateThirdLiteracyData: (state, action) => {
      state.adultLiteracy.AdultLiteracyData = action.payload;
    },
    updateThirdLiteracyDataYear: (state, action) => {
      state.adultLiteracy.AdultLiteracyData = state.adultLiteracy.AdultLiteracyData.map((item) => ({
        ...item,
        Census_Year: action.payload,
      }));
    },
    updateThirdLiteracyDataProvince: (state, action) => {
      state.adultLiteracy.AdultLiteracyData = state.adultLiteracy.AdultLiteracyData.map((item) => ({
        ...item,
        Province_Id: action.payload,
      }));
    },

    // --- Fourth Form Actions --- ✅ Moved inside correctly
    setFourthFormData: (state, action) => {
      state.fourthFormData = action.payload;
    },
    updateSourceOfFourthForm: (state, action) => {
      state.fourthFormData.Source = action.payload;
      state.fourthFormData.ictSkillsData = state.fourthFormData.ictSkillsData.map((item) => ({
        ...item,
        source: action.payload,
      }));
    },
    updateFourthFormData: (state, action) => {
      state.fourthFormData.ictSkillsData = action.payload;
    },
    updateFourthFormDataYear: (state, action) => {
      state.fourthFormData.ictSkillsData = state.fourthFormData.ictSkillsData.map((item) => ({
        ...item,
        Census_Year: action.payload,
      }));
    },
    updateFourthFormDataProvince: (state, action) => {
      state.fourthFormData.ictSkillsData = state.fourthFormData.ictSkillsData.map((item) => ({
        ...item,
        Province_Id: action.payload,
      }));
    },
 // --- youth Form Actions --- ✅ Moved inside correctly
    // --- Youth Literacy Actions ---
setYouthLiteracyData: (state, action) => {
  state.youthLiteracy = action.payload;
},
updateSourceOfYouthLiteracy: (state, action) => {
  state.youthLiteracy.Source = action.payload;
  state.youthLiteracy.YouthLiteracyRate = state.youthLiteracy.YouthLiteracyRate.map((item) => ({
    ...item,
    source: action.payload,
  }));
},
updateYouthLiteracyRate: (state, action) => {
  state.youthLiteracy.YouthLiteracyRate = action.payload;
},
updateYouthLiteracyYear: (state, action) => {
  state.youthLiteracy.YouthLiteracyRate = state.youthLiteracy.YouthLiteracyRate.map((item) => ({
    ...item,
    Census_Year: action.payload,
  }));
},
updateYouthLiteracyProvince: (state, action) => {
  state.youthLiteracy.YouthLiteracyRate = state.youthLiteracy.YouthLiteracyRate.map((item) => ({
    ...item,
    Province_Id: action.payload,
  }));
},

  }
});

export const {
  // First Form
  setFirstFormData,
  updateSource,
  updateLiteracyData,
  updateLiteracyDataYear,
  updateLiteracyDataProvince,

  // Second Form
  setSecondFormData,
  updateSourceOfSecondForm,
  updateSecondLiteracyData,
  updateSecondLiteracyDataYear,
  updateSecondLiteracyDataProvince,

  // Third Form
  setThirdFormData,
  updateSourceOfThirdForm,
  updateThirdLiteracyData,
  updateThirdLiteracyDataYear,
  updateThirdLiteracyDataProvince,

// fourth form
   setFourthFormData,
  updateSourceOfFourthForm,
  updateFourthFormData,
  updateFourthFormDataYear,
  updateFourthFormDataProvince,

  // Youth Literacy
setYouthLiteracyData,
updateSourceOfYouthLiteracy,
updateYouthLiteracyRate,
updateYouthLiteracyYear,
updateYouthLiteracyProvince,

} = formSlice.actions;


export default formSlice.reducer;
